module.exports = __webpack_public_path__ + "img/btn_untitled.cbe00610.png";